var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 180,
    viewBox: "0 0 200 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 70H10V170H190V70Z",
    fill: "#3E523C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 70L100 120L10 170V70Z",
    fill: "#4A6148"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190 70L100 120L190 170V70Z",
    fill: "#4A6148"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 170L100 120L190 170H10Z",
    fill: "#364734"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 70C10 70 80 135 100 135C120 135 190 70 190 70H10Z",
    fill: "#3E523C",
    stroke: "#364734",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.9ace624e98c83997938df3d2b7f54757.svg";
export { ForwardRef as ReactComponent };